// extracted by mini-css-extract-plugin
export default {"relationship":"FamilyHistorySection_relationship__WE1Gy","problem":"FamilyHistorySection_problem__kEICV"};